module.exports = __webpack_public_path__ + "static/media/background.b93c855b.png";